
import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import store from "@/store";
@Component({
  components: {},
})
export default class business extends Vue {
  // 字典
  config = store.state.system.config;
  d: any = {};

  loading = false;

  getData(data: any) {
    this.person[this.index].fdbcczmcl_list = [...this.person[this.index].fdbcczmcl_list, ...data]
    let l: any = []
    this.person[this.index].fdbcczmcl_list.forEach((item: any) => {
      let str = ''
      str = item.filecode + '|' + item.name
      l.push(str)
    })
    this.person[this.index].fdbcczmcl = l.join(',')
  }
  scPer(index: any, idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.person[index].fdbcczmcl_list.splice(idx, 1)
      let l: any = []
      this.person[index].fdbcczmcl_list.forEach((item: any) => {
        let str = ''
        str = item.filecode + '|' + item.name
        l.push(str)
      })
      this.person[index].fdbcczmcl = l.join(',')
    })

  }
  index: any
  getIndex(index: any) {
    this.index = index
  }

  getData2(data: any) {
    this.company[this.index2].fdbcczmcl_list = [...this.company[this.index2].fdbcczmcl_list, ...data]
    let l: any = []
    this.company[this.index2].fdbcczmcl_list.forEach((item: any) => {
      let str = ''
      str = item.filecode + '|' + item.name
      l.push(str)
    })
    this.company[this.index2].fdbcczmcl = l.join(',')
  }
  scCom(index: any, idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.company[index].fdbcczmcl_list.splice(idx, 1)
      let l: any = []
      this.company[index].fdbcczmcl_list.forEach((item: any) => {
        let str = ''
        str = item.filecode + '|' + item.name
        l.push(str)
      })
      this.company[index].fdbcczmcl = l.join(',')
    })

  }
  index2: any
  getIndex2(index: any) {
    this.index2 = index
  }

  appendixs: any = []
  getData3(data: any) {
    this.appendixs = [...this.appendixs, ...data]
  }
  scAppendixs(idx: any) {
    this.$confirm('是否删除该项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.appendixs.splice(idx, 1)
    })

  }

  // 变更业务信息
  change(type: any) {
    this.nonbid.only_safe = type == 1 ? 1 : 2
    this.nonbid.order_code = this.o.order_code
    this.nonbid.op_id = this.o.op_id
    this.nonbid.product_id = this.o.product_id
    this.nonbid.org_id = this.o.org_id
    this.nonbid.bond_type = this.o.bond_type
    this.nonbid.org_type = this.o.org_type
    this.nonbid.letter_money = this.o.letter_money
    this.nonbid.project_name = this.o.project_name
    this.nonbid.channel_id = this.o.channel_id
    this.nonbid.outorg_name = this.o.outorg_name
    this.nonbid.org_zj = this.o.org_zj
    this.nonbid.account_manager = this.o.account_manager
    this.nonbid.letter_type = this.o.letter_type
    // 被保证人所在地省市区
    if(this.casValue.length >0) {
      this.nonbid.warrantee_one = this.casValue[0]
      this.nonbid.warrantee_two = this.casValue[1]
      this.nonbid.warrantee_three = this.casValue[2]
    }

    // 项目  project_szd
    if(this.project_szd.length > 0) {
      this.nonbid.project_one = this.project_szd[0]
      this.nonbid.project_two = this.project_szd[1]
      this.nonbid.project_three = this.project_szd[2]
    }

    // 附件
    let a: any = []
    if(this.appendixs) {
      this.appendixs.forEach((item: any) => {
        let str = item.filecode + '|' + item.name
        a.push(str)
      })
      this.nonbid.appendixs = a.join(',')
    }

    // 删除字段
    delete this.nonbid.status
    delete this.nonbid.letter_status
    delete this.nonbid.pay_status
    delete this.nonbid.sign_status
    delete this.nonbid.created_at
    delete this.nonbid.updated_at
    delete this.nonbid.bond_type_text
    // delete this.nonbid.org_type_type
    delete this.nonbid.letter_period_type_text
    delete this.nonbid.letter_period_text
    delete this.nonbid.pay_method_text
    delete this.nonbid.status_text
    delete this.nonbid.letter_status_text
    delete this.nonbid.pay_status_text
    delete this.nonbid.letter_type_name
    delete this.nonbid.wt_gsfs_text
    delete this.nonbid.letter_sign_text

    api.post('A2006', this.nonbid).then(res => {
      this.$message.success('操作成功')
      this.getInfo()
    })
  }

  private nonbid: {
    [propName: string]: any;
  } = {
    org_price: '', // 收费信息-机构报价
    manager_fee: '', // 客户流量费
    bond_fee: '', // 保证金
    pay_method: '', // 缴纳方式
    bond_fee_dj: '', // 代垫费用
    ljfee_jsfs: '', // 流量费结算方式
    coupon_or: '', // 是否使用优惠券
    coupon_id: '', // 优惠券id
    coupon_type: '', // 优惠券类型
    coupon_money: '', // 优惠券金额
    coupon_mobile: '', // 优惠指定手机
    fee_total: '', // 总收费
    project_one: '',
    project_two: '',
    project_three: '',
    warrantee: '', // 被保证人名称
    warrantee_one: '', // 被保证人所在地
    warrantee_two: '', // 被保证人所在地
    warrantee_three: '', // 被保证人所在地
    warrantee_address: '', // 详细地址
    warrantee_xycode: '', // 被保证人信用代码
    warrantee_jglx: '', // 机构类型
    warrantee_zcsj: '', // 注册成立时间
    warrantee_fr: '', // 企业法人
    warrantee_frsfz: '', // 企业法人证件号
    warrantee_frdh: '', // 企业法人电话
    warrantee_frsfzend: '', // 企业法人身份证到期日
    warrantee_zcjb: '', // 注册资本
    warrantee_sjzb: '', // 实缴资本
    warrantee_cbrs: '', // 参保人数
    warrantee_sjbg: '', // 是否有审计报告
    warrantee_zgzz: '', // 企业最高资质
    warrantee_nsrsf: '', // 纳税人身份
    warrantee_sglb: '', // 施工类别
    warrantee_zzlb: '', // 资质类别
    warrantee_lxr: '', // 联系人
    warrantee_dh: '', // 联系电话
    warrantee_yb: '', // 邮编
    warrantee_cz: '', // 传真
    warrantee_sshy: '', // 所属行业
    warrantee_sflhbbzr: '', // 是否有联合被保证人
    warrantee_lhbbzr: '', // 联合被保证人
    warrantee_lhbbzrxydm: '', // 联合被保证人信用代码
    beneficiary: '', // 受益人名称
    beneficiary_xydm: '', // 受益人信用代码
    beneficiary_jglx: '', // 机构类型
    beneficiary_sflhsyr: '', // 是否有联合受益人
    beneficiary_lhsyr: '', // 联合受益人
    beneficiary_lhsyrxydm: '', // 联合受益人信用代码
    project_name: '', // 项目名称
    project_type: '', // 项目类别
    project_ywlx: '', // 申请业务类型
    // project_szd: '', // 项目所在地
    project_xxdz: '', // 详细地址
    project_zbj: '', // 中标价/合同价
    project_xfl: '', // 下浮率
    project_zjly: '', // 项目资金来源
    project_zbkzj: '', // 招标控制价
    project_zzyq: '', // 资质要求
    project_zbfs: '', // 招标方式
    project_htqx: '', // 合同期限
    project_sglx: '', // 项目对应施工类型
    project_manager: '', // 项目负责人
    project_win_time: '', // 中标时间
    project_zzlx: '', // 项目对应资质类型
    project_fzrsj: '', // 负责人手机号
    project_htqdsj: '', // 合同签订时间
    project_zzdj: '', // 项目对应资质等级
    project_jldw: '', // 监理单位
    project_sjkgr: '', // 实际开工时间
    project_gcqq: '', // 工程起期
    project_gczq: '', // 工程止期
    project_yzmc: '', // 业主方名称
    project_yzxydm: '', // 业主方信用代码
    project_yzjglx: '', // 机构类型
    project_yzcbf: '', // 总承包方名称
    project_yzcbfxydm: '', // 总承包方信用代码
    project_yzcbfjglx: '', // 机构类型
    wt_qsfs: '', // 签署方式
    wt_htmb: '', // 合同模板
    wt_qsr: '', // 签署人姓名
    wt_qsrhm: '', // 签署人手机号码
    wt_qsrzk: '', // 签署人证件号码
    wt_qsrzjend: '', // 签署人证件到期日
    person: [], // 个人反担保
    company: [], // 公司反担保
    credit: [], // 征信查询函
    appendixs: '', // 附件信息
    remark: '', // 备注
  };


  private errors: {
    [propName: string]: any;
  } = {
    org_price: '', // 收费信息-机构报价
    manager_fee: '', // 客户流量费
    bond_fee: '', // 保证金
    pay_method: '', // 缴纳方式
    bond_fee_dj: '', // 代垫费用
    ljfee_jsfs: '', // 流量费结算方式
    coupon_or: '', // 是否使用优惠券
    coupon_id: '', // 优惠券id
    coupon_type: '', // 优惠券类型
    coupon_money: '', // 优惠券金额
    coupon_mobile: '', // 优惠指定手机
    warrantee: '', // 被保证人名称
    warrantee_area: '', // 被保证人所在地
    warrantee_address: '', // 详细地址

  };

  // 地区选择
  casValue: any = [];
  tag: any = -1; // 标识符（重要）
  changeQY2(item: any) {
    let isGo = false;
    let _tag = 0;
    item.forEach((i: any) => {
      if (i[0] != this.tag) {
        isGo = true;
        _tag = i[0];
      }
    });
    if (isGo) {
      let filterd = item.filter((v: any) => v[0] != this.tag);
      this.tag = _tag;
      this.casValue = filterd;
    }
  }

  project_szd: any = []
  tag2: any = -1; // 标识符（重要）
  changeQY(item: any) {
    let isGo = false;
    let _tag = 0;
    item.forEach((i: any) => {
      if (i[0] != this.tag2) {
        isGo = true;
        _tag = i[0];
      }
    });
    if (isGo) {
      let filterd = item.filter((v: any) => v[0] != this.tag2);
      this.tag2 = _tag;
      this.project_szd = filterd;
    }
  }

  // 省市区
  qhdm = []
  getQhdm() {
    api.getQhdm({}).then(res => {
      this.qhdm = res
    })
  }

  // 录单
  btnloading = false
  ludan(type: any) {
    this.nonbid.only_safe = type == 1 ? 1 : 2
    this.nonbid.order_code = this.o.order_code
    this.nonbid.op_id = this.o.op_id
    this.nonbid.product_id = this.o.product_id
    this.nonbid.org_id = this.o.org_id
    this.nonbid.bond_type = this.o.bond_type
    this.nonbid.org_type = this.o.org_type
    this.nonbid.letter_money = this.o.letter_money
    this.nonbid.project_name = this.o.project_name
    this.nonbid.channel_id = this.o.channel_id
    this.nonbid.outorg_name = this.o.outorg_name
    this.nonbid.org_zj = this.o.org_zj
    this.nonbid.account_manager = this.o.account_manager
    this.nonbid.letter_type = this.o.letter_type
    this.nonbid.letter_period = this.o.letter_period
    this.nonbid.letter_period_date = this.o.letter_period_date
    this.nonbid.letter_period_type = this.o.letter_period_type
    this.nonbid.wt_htmb = this.templates.entrust.filecode
    this.nonbid.wt_qsfs = this.templates.entrust.sing_method
    this.nonbid.sign_method  = this.o.letter_sign_method
    // 被保证人所在地省市区
    if(this.casValue.length >0) {
      this.nonbid.warrantee_one = this.casValue[0]
      this.nonbid.warrantee_two = this.casValue[1]
      this.nonbid.warrantee_three = this.casValue[2]
    }

    // 项目  project_szd
    if(this.project_szd.length > 0) {
      this.nonbid.project_one = this.project_szd[0]
      this.nonbid.project_two = this.project_szd[1]
      this.nonbid.project_three = this.project_szd[2]
    }
    // 遍历person company
    let templates = this.templates
    let person: any = []
    this.person.forEach((item: any) => {
      item.fdbhtmb = templates.per_fdb.filecode
      item.fdbhtmb_filecode = templates.per_fdb.filecode
      item.fdbhtmb_filename = templates.per_fdb.name
      item.sign_method = templates.per_fdb.sing_method

      if(item.fdbcs && item.fdbdx) {
        person.push(item)
      }
    })

    let company: any = []
    this.company.forEach((item: any) => {
      item.fdbhtmb = templates.com_fdb.filecode
      item.fdbhtmb_filecode = templates.com_fdb.filecode
      item.fdbhtmb_filename = templates.com_fdb.name
      item.sign_method = templates.com_fdb.sing_method

      if(item.fdbcs && item.fdbdx) {
        company.push(item)
      }
    })

    let credit: any = []
    this.credit.forEach((item: any) => {
      item.zxmb = templates.credit.filecode
      item.zxmb_filecode = templates.credit.filecode
      item.zxmb_filename = templates.credit.name
      item.sign_method = templates.credit.sing_method

      if(item.sign_person) {
        credit.push(item)
      }
    })
    this.nonbid.person = person
    this.nonbid.company = company
    this.nonbid.credit = credit

    // 附件
    let a: any = []
    if(this.appendixs) {
      this.appendixs.forEach((item: any) => {
        let str = item.filecode + '|' + item.name
        a.push(str)
      })
      this.nonbid.appendixs = a.join(',')
    }

    this.btnloading = true
    api.post('A2002', this.nonbid).then(res => {
      this.$message.success('操作成功')
      this.getInfo()
      this.$router.back()
    }).finally(() => {
      this.btnloading = false
    })
  }

  edit(type: any) {
    this.nonbid.only_safe = type == 1 ? 1 : 2
    // 被保证人所在地省市区
    if(this.casValue.length >0) {
      this.nonbid.warrantee_one = this.casValue[0]
      this.nonbid.warrantee_two = this.casValue[1]
      this.nonbid.warrantee_three = this.casValue[2]
    }

    // 项目  project_szd
    if(this.project_szd.length > 0) {
      this.nonbid.project_one = this.project_szd[0]
      this.nonbid.project_two = this.project_szd[1]
      this.nonbid.project_three = this.project_szd[2]
    }

    // 遍历person company
    let templates = this.templates
    let person: any = []
    this.person.forEach((item: any) => {
      item.fdbhtmb = templates.per_fdb.filecode
      item.fdbhtmb_filecode = templates.per_fdb.filecode
      item.fdbhtmb_filename = templates.per_fdb.name
      item.sign_method = templates.per_fdb.sing_method

      if(item.fdbcs && item.fdbdx) {
        person.push(item)
      }
    })

    let company: any = []
    this.company.forEach((item: any) => {
      item.fdbhtmb = templates.com_fdb.filecode
      item.fdbhtmb_filecode = templates.com_fdb.filecode
      item.fdbhtmb_filename = templates.com_fdb.name
      item.sign_method = templates.com_fdb.sing_method

      if(item.fdbcs && item.fdbdx) {
        company.push(item)
      }
    })

    let credit: any = []
    this.credit.forEach((item: any) => {
      item.zxmb = templates.credit.filecode
      item.zxmb_filecode = templates.credit.filecode
      item.zxmb_filename = templates.credit.name
      item.sign_method = templates.credit.sing_method

      if(item.sign_person) {
        credit.push(item)
      }
    })
    this.nonbid.person = person
    this.nonbid.company = company
    this.nonbid.credit = credit


    // 附件
    let a: any = []
    this.appendixs.forEach((item: any) => {
      let str = item.filecode + '|' + item.name
      a.push(str)
    })
    this.nonbid.appendixs = a.join(',')

    // 删除字段
    delete this.nonbid.status
    delete this.nonbid.letter_status
    delete this.nonbid.pay_status
    delete this.nonbid.sign_status
    delete this.nonbid.created_at
    delete this.nonbid.updated_at
    delete this.nonbid.bond_type_text
    delete this.nonbid.letter_period_type_text
    delete this.nonbid.letter_period_text
    delete this.nonbid.pay_method_text
    delete this.nonbid.status_text
    delete this.nonbid.letter_status_text
    delete this.nonbid.pay_status_text
    delete this.nonbid.letter_type_name
    delete this.nonbid.wt_gsfs_text
    delete this.nonbid.letter_sign_text

    this.btnloading = true
    api.post('A2005', this.nonbid).then(res => {
      this.$message.success('操作成功')
      this.getInfo()
      this.$router.back()
    }).finally(() => {
      this.btnloading = false
    })
  }



  // 添加个人反担保
  person: any = [
    {
      sign_method:"",
      type:"per_fdb",
      fdbcs:"",
      fdbdx:"",
      fdbdxzj:"",
      fdbsjh:"",
      fdbhtmb:"",
      fdbcczmcl:"",
      fdbrtxdz:"",
      fdbcczmcl_list: []
    }
  ]
  addPeopleFDB() {
    this.person.push({
        sign_method:"",
        type:"per_fdb",
        fdbcs:"",
        fdbdx:"",
        fdbdxzj:"",
        fdbsjh:"",
        fdbhtmb:"",
        fdbcczmcl:"",
        fdbrtxdz:"",
        fdbcczmcl_list: []
    })
  }

  // 删除个人反担保
  delPer(row: any, index: any) {
    let del = () => {
      this.person.splice(index, 1)
    }
    if(row.id) {
      this.$confirm('是否删除该项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delMeasures({id: row.id}).then(res => {
          del()
          this.$message.success('操作成功')
        })
      })
      return
    }
    del()
  }

  // 添加企业反担保
  company: any = [
    {
      sign_method:"",
      type:"comp_fdb",
      fdbcs:"",
      fdbdx:"",
      fdbdxzj:"",
      fdbsjh:"",
      fdbhtmb:"",
      fdbcczmcl:"",
      fdbrtxdz:"",
      fdbcczmcl_list: []
    }
  ]
  addCompanyFDB() {
    this.company.push({
        sign_method:"",
        type:"comp_fdb",
        fdbcs:"",
        fdbdx:"",
        fdbdxzj:"",
        fdbsjh:"",
        fdbhtmb:"",
        fdbcczmcl:"",
        fdbrtxdz:"",
        fdbcczmcl_list: []
    })
  }
  // 删除公司反担保
  delCom(row: any, index: any) {
    let del = () => {
      this.company.splice(index, 1)
    }
    if(row.id) {
      this.$confirm('是否删除该项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delMeasures({id: row.id}).then(res => {
          del()
          this.$message.success('操作成功')
        })
      })
      return
    }
    del()
  }

  //添加征信查询函
  credit: any = [
    {
      sign_method:"",
      zxmb:"",
      sign_person:""
    }
  ]
  addZhengxinCXH() {
    this.credit.push({
      sign_method:"",
      zxmb:"",
      sign_person:""
    })
  }
  // 删除征信查询函
  delCre(row: any, index: any) {
    let del = () => {
      this.credit.splice(index, 1)
    }
    if(row.id) {
      this.$confirm('是否删除该项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delMeasures({id: row.id}).then(res => {
          del()
          this.$message.success('操作成功')
        })
      })
      return
    }
    del()
  }

  muban = {}
  getTplSection() {
    api.getTplSection({org_id: this.o.org_id, bond_type: this.o.bond_type}).then(res => {
      this.muban = res
    })
  }

  templates: any = {
    com_fdb: {sing_method: ''},
    credit: {sing_method: ''},
    letter: {sing_method: ''},
    per_fdb: {sing_method: ''},
    entrust: {sing_method: ''},
  }
  getInfo() {
    api
            .post("A2007", {order_code: this.$route.query.code})
            .then((data: any) => {
              this.o = data.order_info;
              this.templates = data.order_info.templates
              this.nonbid.warrantee = data.order_info.warrantee
              this.nonbid.beneficiary = data.order_info.beneficiary
              this.nonbid.project_name = data.order_info.project_name

              this.getTplSection()
              if(JSON.stringify(data.apply_info) != "{}") {
                this.nonbid = data.apply_info;
                this.appendixs = data.apply_info.appendixs
                // 省市区
                this.casValue = [this.nonbid.warrantee_one, this.nonbid.warrantee_two, this.nonbid.warrantee_three]
                this.project_szd = [this.nonbid.project_one, this.nonbid.project_two, this.nonbid.project_three]

                this.person = this.nonbid.person.length > 0 ? this.nonbid.person : this.person
                this.company = this.nonbid.company.length > 0 ? this.nonbid.company : this.company
                this.credit = this.nonbid.credit.length > 0 ? this.nonbid.credit : this.credit

                this.nonbid.coupon_or = this.nonbid.coupon_or == 0 ? '' : this.nonbid.coupon_or.toString()
                this.nonbid.warrantee_jglx = this.nonbid.warrantee_jglx == 0 ? '' : this.nonbid.warrantee_jglx.toString()
                this.nonbid.warrantee_sjbg = this.nonbid.warrantee_sjbg == 0 ? '' : this.nonbid.warrantee_sjbg.toString()
                this.nonbid.warrantee_zgzz = this.nonbid.warrantee_zgzz == 0 ? '' : this.nonbid.warrantee_zgzz.toString()
                this.nonbid.warrantee_sglb = this.nonbid.warrantee_sglb == 0 ? '' : this.nonbid.warrantee_sglb.toString()
                this.nonbid.warrantee_nsrsf = this.nonbid.warrantee_nsrsf == 0 ? '' : this.nonbid.warrantee_nsrsf.toString()
                this.nonbid.warrantee_zzlb = this.nonbid.warrantee_zzlb == 0 ? '' : this.nonbid.warrantee_zzlb.toString()
                this.nonbid.warrantee_sflhbbzr = this.nonbid.warrantee_sflhbbzr == 0 ? '' : this.nonbid.warrantee_sflhbbzr.toString()
                this.nonbid.beneficiary_jglx = this.nonbid.beneficiary_jglx == 0 ? '' : this.nonbid.beneficiary_jglx.toString()
                this.nonbid.beneficiary_sflhsyr = this.nonbid.beneficiary_sflhsyr == 0 ? '' : this.nonbid.beneficiary_sflhsyr.toString()
                this.nonbid.project_sglx = this.nonbid.project_sglx == 0 ? '' : this.nonbid.project_sglx.toString()
                this.nonbid.project_type = this.nonbid.project_type == 0 ? '' : this.nonbid.project_type.toString()
                this.nonbid.project_zjly = this.nonbid.project_zjly == 0 ? '' : this.nonbid.project_zjly.toString()
                this.nonbid.project_zbfs = this.nonbid.project_zbfs == 0 ? '' : this.nonbid.project_zbfs.toString()
                this.nonbid.project_zzyq = this.nonbid.project_zzyq == 0 ? '' : this.nonbid.project_zzyq.toString()
                this.nonbid.project_zzlx = this.nonbid.project_zzlx == 0 ? '' : this.nonbid.project_zzlx.toString()
                this.nonbid.project_zzdj = this.nonbid.project_zzdj == 0 ? '' : this.nonbid.project_zzdj.toString()
                this.nonbid.project_ywlx = this.nonbid.project_ywlx == 0 ? '' : this.nonbid.project_ywlx.toString()
                this.nonbid.project_yzjglx = this.nonbid.project_yzjglx == 0 ? '' : this.nonbid.project_yzjglx.toString()
                this.nonbid.wt_qsfs = this.nonbid.wt_qsfs == 0 ? '' : this.nonbid.wt_qsfs.toString()

              }


            })
            .finally(() => {
              this.loading = false;
            });
  }
  o: any = {}
  type = ''
  look = false
  activated() {
    api.getDics().then((res) => {
      store.dispatch("system/addConfig", res);
      this.config = store.state.system.config
    });
    this.getQhdm()
    // this.loading = true;
    let {code , form, type, look } = this.$route.query
    this.look = false
    if(type) {
      this.type = type.toString()
    }
    if(look) {
      this.look = true
    }

    this.d = {};
    this.o = {}
    this.appendixs = []
    this.nonbid = {
      org_price: '', // 收费信息-机构报价
      manager_fee: '', // 客户流量费
      bond_fee: '', // 保证金
      pay_method: '', // 缴纳方式
      bond_fee_dj: '', // 代垫费用
      ljfee_jsfs: '', // 流量费结算方式
      coupon_or: '', // 是否使用优惠券
      coupon_id: '', // 优惠券id
      coupon_type: '', // 优惠券类型
      coupon_money: '', // 优惠券金额
      coupon_mobile: '', // 优惠指定手机
      fee_total: '', // 总收费
      project_one: '',
      project_two: '',
      project_three: '',
      warrantee: '', // 被保证人名称
      warrantee_one: '', // 被保证人所在地
      warrantee_two: '', // 被保证人所在地
      warrantee_three: '', // 被保证人所在地
      warrantee_address: '', // 详细地址
      warrantee_xycode: '', // 被保证人信用代码
      warrantee_jglx: '', // 机构类型
      warrantee_zcsj: '', // 注册成立时间
      warrantee_fr: '', // 企业法人
      warrantee_frsfz: '', // 企业法人证件号
      warrantee_frdh: '', // 企业法人电话
      warrantee_frsfzend: '', // 企业法人身份证到期日
      warrantee_zcjb: '', // 注册资本
      warrantee_sjzb: '', // 实缴资本
      warrantee_cbrs: '', // 参保人数
      warrantee_sjbg: '', // 是否有审计报告
      warrantee_zgzz: '', // 企业最高资质
      warrantee_nsrsf: '', // 纳税人身份
      warrantee_sglb: '', // 施工类别
      warrantee_zzlb: '', // 资质类别
      warrantee_lxr: '', // 联系人
      warrantee_dh: '', // 联系电话
      warrantee_yb: '', // 邮编
      warrantee_cz: '', // 传真
      warrantee_sshy: '', // 所属行业
      warrantee_sflhbbzr: '', // 是否有联合被保证人
      warrantee_lhbbzr: '', // 联合被保证人
      warrantee_lhbbzrxydm: '', // 联合被保证人信用代码
      beneficiary: '', // 受益人名称
      beneficiary_xydm: '', // 受益人信用代码
      beneficiary_jglx: '', // 机构类型
      beneficiary_sflhsyr: '', // 是否有联合受益人
      beneficiary_lhsyr: '', // 联合受益人
      beneficiary_lhsyrxydm: '', // 联合受益人信用代码
      project_name: '', // 项目名称
      project_type: '', // 项目类别
      project_ywlx: '', // 申请业务类型
      // project_szd: '', // 项目所在地
      project_xxdz: '', // 详细地址
      project_zbj: '', // 中标价/合同价
      project_xfl: '', // 下浮率
      project_zjly: '', // 项目资金来源
      project_zbkzj: '', // 招标控制价
      project_zzyq: '', // 资质要求
      project_zbfs: '', // 招标方式
      project_htqx: '', // 合同期限
      project_sglx: '', // 项目对应施工类型
      project_manager: '', // 项目负责人
      project_win_time: '', // 中标时间
      project_zzlx: '', // 项目对应资质类型
      project_fzrsj: '', // 负责人手机号
      project_htqdsj: '', // 合同签订时间
      project_zzdj: '', // 项目对应资质等级
      project_jldw: '', // 监理单位
      project_sjkgr: '', // 实际开工时间
      project_gcqq: '', // 工程起期
      project_gczq: '', // 工程止期
      project_yzmc: '', // 业主方名称
      project_yzxydm: '', // 业主方信用代码
      project_yzjglx: '', // 机构类型
      project_yzcbf: '', // 总承包方名称
      project_yzcbfxydm: '', // 总承包方信用代码
      project_yzcbfjglx: '', // 机构类型
      wt_qsfs: '', // 签署方式
      wt_htmb: '', // 合同模板
      wt_qsr: '', // 签署人姓名
      wt_qsrhm: '', // 签署人手机号码
      wt_qsrzk: '', // 签署人证件号码
      wt_qsrzjend: '', // 签署人证件到期日
      person: [], // 个人反担保
      company: [], // 公司反担保
      credit: [], // 征信查询函
      appendixs: '', // 附件信息
      remark: '', // 备注
    }
    this.casValue = []
    this.project_szd = []
    this.person = [{
      sign_method:"",
      type:"per_fdb",
      fdbcs:"",
      fdbdx:"",
      fdbdxzj:"",
      fdbsjh:"",
      fdbhtmb:"",
      fdbcczmcl:"",
      fdbrtxdz:"",
      fdbcczmcl_list: []
    }]
    this.company = [
      {
        sign_method:"",
        type:"comp_fdb",
        fdbcs:"",
        fdbdx:"",
        fdbdxzj:"",
        fdbsjh:"",
        fdbhtmb:"",
        fdbcczmcl:"",
        fdbrtxdz:"",
        fdbcczmcl_list: []
      }
    ]
    this.credit = [
      {
        sign_method:"",
        zxmb:"",
        sign_person:""
      }
    ]
    this.getInfo()


  }
}
